import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getUpdatedIdeas } from 'src/api/task';

const initialState = {
  ideas: [],
  isLastIdea: false,
  showEmpty: false,
  currentIdea: 0
};

const isLastIdea = ({ ideas, currentIdea }) => ideas.length - 1 === currentIdea;

/* eslint-disable camelcase */
export const refreshIdeas = createAsyncThunk('ideas/refresh', async () =>
  getUpdatedIdeas()
);
/* eslint-enable camelcase */

const setIdeasReducer = (state, payload) => {
  const ideas = [...payload]?.filter(({ title }) => Boolean(title));
  const currentIdea = 0;

  state.ideas = ideas;
  state.currentIdea = currentIdea;
  state.showEmpty = false;
  state.isLastIdea = isLastIdea({
    ideas: ideas,
    currentIdea: currentIdea
  });
};

const ideasSlice = createSlice({
  name: 'ideas',
  initialState,
  reducers: {
    setIdeas(state, action) {
      if (!action?.payload) {
        return;
      }

      setIdeasReducer(state, action.payload);
    },
    nextIdea(state) {
      const nextIdea = state.currentIdea + 1;
      const currentIdea = nextIdea >= state.ideas.length ? 0 : nextIdea;

      state.currentIdea = currentIdea;
      state.isLastIdea = isLastIdea({
        ideas: state.ideas,
        currentIdea: currentIdea
      });
      state.showEmpty = false;
    },
    setShowEmpty(state) {
      state.showEmpty = true;
    }
  },
  extraReducers(builder) {
    const setIdeas = (state, action) => {
      setIdeasReducer(state, action.payload);
    };

    builder.addCase(refreshIdeas.fulfilled, setIdeas);
  }
});

export const {
  setIdeas,
  nextIdea,
  setShowEmpty,
  setRecomendationsSurveyComplete
} = ideasSlice.actions;

export const selectIdeaState = (state) => state.ideas;

export const findIdeaByRecommendationId = (ideas, recommendationId) => {
  const [idea] = ideas?.filter(
    (currentIdea) => currentIdea.recommendation_id === recommendationId
  );
  return idea;
};

export const selectIdeaByRecommendationId = (recommendationId) => (state) =>
  findIdeaByRecommendationId(state.ideas.ideas, recommendationId);

export default ideasSlice.reducer;
